import React from 'react';

const ANCHOR_STORAGE_KEY = 'pendingAnchorScroll';
const ANCHOR_TTL_MS = 15000;

interface StoredAnchor {
  anchor: string;
  path: string;
  ts: number;
}

const getStickyHeaderHeight = () => {
  const header = document.querySelector<HTMLElement>('header');
  return header ? header.offsetHeight : 0;
};

const scrollToAnchor = (anchor: string, retries = 15) => {
  const target = document.querySelector(anchor);
  if (target) {
    const offset = target.getBoundingClientRect().top + window.scrollY - getStickyHeaderHeight() - 32;
    window.scrollTo({ top: offset, behavior: 'smooth' });
    return;
  }
  if (retries > 0) {
    setTimeout(() => scrollToAnchor(anchor, retries - 1), 150);
  }
};

const consumeStoredAnchor = (currentPath: string) => {
  const raw = localStorage.getItem(ANCHOR_STORAGE_KEY);
  if (!raw) return;

  try {
    const stored: StoredAnchor = JSON.parse(raw);
    if (Date.now() - stored.ts > ANCHOR_TTL_MS) {
      localStorage.removeItem(ANCHOR_STORAGE_KEY);
      return;
    }
    const normalize = (p: string) => p.replace(/\/?$/, '/');
    if (normalize(currentPath) === normalize(stored.path)) {
      localStorage.removeItem(ANCHOR_STORAGE_KEY);
      scrollToAnchor(stored.anchor);
    }
  } catch {
    localStorage.removeItem(ANCHOR_STORAGE_KEY);
  }
};

if (typeof document !== 'undefined') {
  document.addEventListener('click', (e) => {
    const el = (e.target as HTMLElement).closest<HTMLElement>('[data-anchor-src]');
    if (el) {
      const anchor = el.getAttribute('data-anchor-src');
      const href = el.getAttribute('href');
      if (anchor && href) {
        const payload: StoredAnchor = { anchor, path: href, ts: Date.now() };
        localStorage.setItem(ANCHOR_STORAGE_KEY, JSON.stringify(payload));
      }
    }
  });
}

// Handles new-tab (full page load) navigation
export const onInitialClientRender = () => {
  consumeStoredAnchor(window.location.pathname);
};

// Handles same-tab SPA navigation
export const onRouteUpdate = ({ location }: { location: Location }) => {
  consumeStoredAnchor(location.pathname);
};
